import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Auth0ProviderWithHistory } from "./auth/Auth0ProviderWithHistory";
import { BetaSignupProvider } from "./context/BetaSignupContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BetaSignupModal from "./components/BetaSignupModal";
import Home from "./pages/Home";
import Offerings from "./pages/Offerings";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import HowTroveWorks from "./pages/HowTroveWorks";
import Careers from "./pages/Careers";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Disclosures from "./pages/Disclosures";
import Goals from "./pages/Goals";
import Activity from "./pages/Activity";
import Settings from "./pages/Settings";
import IconTest from "./pages/IconTest";
import StrategyDetail from "./pages/StrategyDetail";
import Onboarding from "./pages/OnboardingNew";
import Banking from "./pages/Banking";
import GoalDetail from "./pages/GoalDetail";
import ReferralRedirect from "./pages/ReferralRedirect";
import BlogArticle from "./pages/BlogArticle";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <BetaSignupProvider>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/offerings" element={<Offerings />} />
              <Route path="/strategy/:id" element={<StrategyDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogArticle />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
              <Route path="/activity" element={<ProtectedRoute><Activity /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/banking" element={<ProtectedRoute><Banking /></ProtectedRoute>} />
              <Route path="/goal/:goalId" element={<ProtectedRoute><GoalDetail /></ProtectedRoute>} />
              <Route path="/how-trove-works" element={<HowTroveWorks />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/disclosures" element={<Disclosures />} />
              <Route path="/r/:code" element={<ReferralRedirect />} />
            </Routes>
            <Footer />
            <Toaster />
            <BetaSignupModal />
          </BetaSignupProvider>
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </div>
  );
}

export default App;
